<!--
/**
* @name: List.vue
* @description: 优惠券管理列表页
* @author: 杨波
* @create: 2020/08/11 09:40:37
* @update: 2020/08/11 09:40:37
*/
-->

<template>
  <y-view :loading="isLoading">
    <y-query spaceBetween :hasSearchButton="false">
      <y-query-item>
        <k-input :class="css.inputW" placeholder="请输入优惠券名称" block clearable v-model="para.bonusName"></k-input>
      </y-query-item>
      <y-query-item>
        <k-select :class="css.inputW" placeholder="请选择推广渠道" clearable block v-model="para.promoteChannel">
          <k-option v-for="item in promoteList" :key="item.value" :value="item.value" :label="item.label">{{ item.label }}</k-option>
        </k-select>
      </y-query-item>
      <y-query-item>
        <k-select :class="css.inputW" placeholder="请选择销售渠道" clearable block v-model="para.saleChannelCode">
          <k-option v-for="item in channelList" :key="item.code" :value="item.code" :label="item.name">{{ item.name }}</k-option>
        </k-select>
      </y-query-item>
      <y-query-item slot="right">
        <y-button icon="k-icon-add" @click="onAdd">新建</y-button>
      </y-query-item>
    </y-query>
    <y-query spaceBetween :hasSearchButton="false">
      <y-query-item>
        <k-select :class="css.inputW" placeholder="请选择优惠券发放方式" clearable block v-model="para.provideType">
          <k-option v-for="item in typeList" :key="item.value" :value="item.value" :label="item.label">{{ item.label }}</k-option>
        </k-select>
      </y-query-item>
      <y-query-item>
        <k-select :class="css.inputW" placeholder="请选择优惠券状态" clearable block v-model="para.status">
          <k-option v-for="item in statusTempList" :key="item.value" :value="item.value" :label="item.label">{{ item.label }}</k-option>
        </k-select>
      </y-query-item>
      <y-query-item>
        <k-select placeholder="请选择启停用状态" clearable block v-model="para.isEnabled" :class="css.inputW">
          <k-option v-for="item in statusList" :key="item.value" :value="item.value" :label="item.label">{{ item.label }}</k-option>
        </k-select>
      </y-query-item>
      <y-query-item>
        <k-button type="primary" @click="onSearch">查询</k-button>
      </y-query-item>
      <y-query-item>
        <k-button @click="onReset">重置</k-button>
      </y-query-item>
    </y-query>
    <!-- 审核确认弹窗区域 -->
    <k-popup bind="v-if" cancelText="驳回" okText="通过" title="确认审核" :show.sync="popupAuditingShow" @after-cancel="refuse" @after-ok="agree">
      <div style="width: 650px;">
        该活动一经审核通过不可修改，请注意。
      </div>
    </k-popup>
    <!-- 审核确认弹窗区域 end-->
    <!-- 审核驳回原因填写弹窗区域 -->
    <k-popup bind="v-if" title="填写驳回原因" :show.sync="popupShow" @after-ok="save">
      <div style="width: 650px;">
        <y-form titleAlign="right" titleWidth="100px" contentWidth="400px">
          <y-form-item title="驳回原因:" align="top" required>
            <k-input tag="textarea" :class="css.textarea" v-model="rejectCause" block placeholder="请输入驳回原因..."></k-input>
          </y-form-item>
        </y-form>
      </div>
    </k-popup>
    <!-- 审核驳回原因填写弹窗区域 end-->
    <!-- 审核驳回原因展示弹窗区域 -->
    <k-popup bind="v-if" title="您得申请已被驳回！" :show.sync="isShowReasonpopup" @after-ok="onSure">
      <div style="width: 650px;">驳回原因：{{ rejectCause }}</div>
    </k-popup>
    <!-- 审核驳回原因展示弹窗区域 end-->
    <k-table :data="dataList" :height="$root.tableHeightXX" :rightFixedNumber="1" :columns="initColumns()"></k-table>
    <k-pagination :total="total" :current-page.sync="para.pageCurrent" :page-size.sync="para.pageSize" @page-change="onChangePageIndex" />
  </y-view>
</template>

<script>
import {
  NESTLE_MARKETING_BACK_SERVER_BONUS_PAGE,
  NESTLE_SYSTEM_BACK_SERVER_SYSTEM_SALE_CHANNEL_LIST,
  NESTLE_MARKETING_BACK_SERVER_BONUS_ENABLED,
  NESTLE_MARKETING_BACK_SERVER_BONUS_DISABELD,
  NESTLE_MARKETING_BACK_SERVER_BONUS_AUDIT,
  NESTLE_MARKETING_BACK_SERVER_BONUS_CANCEL,
} from "@/assets/modules/apiList";
const initPara = () => ({
  provideType: "",
  status: "",
  promoteChannel: "",
  bonusName: "",
  saleChannelCode: "",
  isEnabled: "",
  pageCurrent: 1,
  pageSize: 15,
});
export default {
  data() {
    return {
      isLoading: false,
      dataList: [],
      para: initPara(),
      promoteList: [
        { value: "C_CLIENT", label: "C端" },
        { value: "B_CLIENT", label: "B端" },
        { value: "VALET", label: "代客下单" },
      ],
      typeList: [
        { value: "SHARE", label: "分享" },
        { value: "EXCHANGE", label: "兑换码" },
        { value: "ASSIGN", label: "定向发放" },
        { value: "ONLINE", label: "线上领取" },
      ],
      statusTempList: [
        { value: "WAIT", label: "待审核" },
        { value: "VERIFING", label: "审核中" },
        { value: "REJECTED", label: "已驳回" },
        { value: "PASSED", label: "已通过" },
        { value: "EXPIRED", label: "已结束" },
        { value: "ONGOING", label: "进行中" },
      ],
      statusList: [
        {
          label: "启用",
          value: true,
        },
        {
          label: "停用",
          value: false,
        },
      ],
      channelList: [],
      total: 0,
      popupAuditingShow: false,
      isShowReasonpopup: false,
      popupShow: false,
      rejectCause: "",
      couponId: "",
    };
  },
  methods: {
    initColumns() {
      return [
        {
          name: "编码",
          field: "id",
          style: {
            textAlign: "center",
          },
        },
        {
          name: "优惠券名称",
          field: "bonusName",
          style: {
            textAlign: "center",
            "white-space": "normal",
            "line-height": "18px",
          },
        },
        {
          name: "销售渠道",
          field: "saleChannelName",
          style: {
            textAlign: "center",
          },
        },
        {
          name: "推广渠道",
          style: {
            textAlign: "center",
          },
          customRender: (row) => {
            let temp = "";
            for (let i = 0; i < this.promoteList.length; i++) {
              if (row.promoteChannel == this.promoteList[i].value) {
                temp = this.promoteList[i].label;
                break;
              }
            }
            return <div>{temp}</div>;
          },
        },
        {
          name: "发送方式",
          style: {
            textAlign: "center",
          },
          customRender: (row) => {
            let temp = "";
            for (let i = 0; i < this.typeList.length; i++) {
              if (row.provideType == this.typeList[i].value) {
                temp = this.typeList[i].label;
                break;
              }
            }
            return <div>{temp}</div>;
          },
        },
        {
          name: "面值",
          field: "bonusValue",
          style: {
            textAlign: "center",
          },
        },
        {
          name: "状态",
          style: {
            textAlign: "center",
            overflow: "initial",
          },
          customRender: (row) => {
            let temp = "";
            for (let i = 0; i < this.statusTempList.length; i++) {
              if (row.status == this.statusTempList[i].value) {
                temp = this.statusTempList[i].label;
                break;
              }
            }
            if (row.status == "REJECTED") {
              return (
                <div class={this.css.box}>
                  <span class={this.css.statusStyle}></span>
                  <span>{temp}</span>
                  <k-icon class="k-icon-tip" color="rgba(0,0,0,.45)" style="margin-left:2px;font-size:14px;"></k-icon>
                  <div class={this.css.tip}>{row.rejectCause}</div>
                </div>
              );
            } else {
              return (
                <div>
                  <span class={this.css.statusStyle}></span>
                  <span>{temp}</span>
                  <k-icon class="k-icon-tip" color="rgba(0,0,0,.45)" style="margin-left:2px;font-size:14px;opacity:0"></k-icon>
                </div>
              );
            }
          },
        },
        {
          name: "启停用状态",
          style: {
            width: 100,
            textAlign: "center",
          },
          customRender: (row) => (
            <k-switch
              checked={row.isEnabled}
              readonly
              onClick={() => {
                this.onChangeStatus(row);
              }}
            />
          ),
        },
        {
          name: "使用有效期",
          field: "create_time_str",
          style: { textAlign: "center", width: 250 },
          customRender: (row) => {
            return (
              <div>
                {row.useStartTime}~{row.useEndTime}
              </div>
            );
          },
        },
        {
          name: "操作",
          field: "action",
          style: { width: 180, textAlign: "center" },
          customRender: (row) => {
            const previewButton = (
              <a
                href="javascript:void(0);"
                onClick={() => {
                  this.onView(row);
                }}
              >
                查看
              </a>
            );
            const editButton = (
              <a
                href="javascript:void(0);"
                onClick={() => {
                  if (row.status == "REJECTED") {
                    this.onShowRejectCause(row);
                  } else {
                    this.onEdit(row);
                  }
                }}
              >
                编辑
              </a>
            );
            const grantButton = (
              <a
                href="javascript:void(0);"
                onClick={() => {
                  this.onGrant(row);
                }}
              >
                发放
              </a>
            );
            const auditingButton = (
              <a
                href="javascript:void(0);"
                onClick={() => {
                  this.onAudit(row);
                }}
              >
                审核
              </a>
            );
            const detailButton = (
              <a
                href="javascript:void(0);"
                onClick={() => {
                  this.onDetail(row);
                }}
              >
                详情
              </a>
            );
            if (row.status == "WAIT") {
              return (
                <div>
                  {previewButton}&#12288;{editButton}&#12288;{auditingButton}
                </div>
              );
            } else if (row.status == "REJECTED") {
              return (
                <div>
                  {previewButton}&#12288;{editButton}
                </div>
              );
            } else if (row.status == "PASSED" && row.isEnabled && row.provideType == "ASSIGN" && row.noGiveNumber > 0) {
              return (
                <div>
                  {previewButton}&#12288;{grantButton}&#12288;{detailButton}
                </div>
              );
            } else if ((row.status == "PASSED" && row.provideType != "ASSIGN") || (row.status == "PASSED" && !row.isEnabled && row.provideType == "ASSIGN")) {
              return (
                <div>
                  {previewButton}&#12288;{detailButton}
                </div>
              );
            } else if (row.status == "PASSED" && row.isEnabled && row.provideType == "ASSIGN" && row.noGiveNumber == 0) {
              return (
                <div>
                  {previewButton}&#12288;{detailButton}
                </div>
              );
            } else if (row.status == "EXPIRED") {
              return (
                <div>
                  {previewButton}&#12288;{detailButton}
                </div>
              );
            } else if (row.status == "ONGOING") {
              if (row.provideType == "ASSIGN" && row.noGiveNumber > 0) {
                return (
                  <div>
                    {previewButton}&#12288;{detailButton}&#12288;{grantButton}
                  </div>
                );
              } else {
                return (
                  <div>
                    {previewButton}&#12288;{detailButton}
                  </div>
                );
              }
            }
          },
        },
      ];
    },
    onAdd() {
      this.$controller.open({
        name: "couponAdd",
        query: {
          refresh: new Date() - 0,
        },
      });
    },
    onView(row) {
      this.$controller.open({
        name: "couponAdd",
        query: {
          refresh: new Date() - 0,
          id: row.id,
          view: 1,
        },
        title: "查看优惠券详情",
      });
    },
    onEdit(row) {
      this.$controller.open({
        name: "couponAdd",
        query: {
          refresh: new Date() - 0,
          id: row.id,
          edit: 1,
        },
        title: "编辑优惠券",
      });
    },
    onGrant(row) {
      this.$controller.open({
        name: "grantRecord",
        query: {
          refresh: new Date() - 0,
          id: row.id,
          name: row.bonusName,
          type: row.promoteChannel,
        },
      });
    },
    onDetail(row) {
      this.$controller.open({
        name: "couponGrantDetail",
        query: {
          refresh: new Date() - 0,
          id: row.id,
        },
      });
    },
    onAudit(row) {
      this.couponId = row.id;
      this.popupAuditingShow = true;
    },
    onSearch() {
      this.para.pageCurrent = 1;
      this.getCouponList();
    },
    onReset() {
      this.para = initPara();
      this.getCouponList();
    },
    onChangePageIndex(p) {
      this.para.pageCurrent = p;
      this.getCouponList();
    },
    onChangeStatus(row) {
      let api = NESTLE_MARKETING_BACK_SERVER_BONUS_ENABLED;
      if (row.isEnabled) {
        api = NESTLE_MARKETING_BACK_SERVER_BONUS_DISABELD;
      }
      this.$dialog({
        title: "提示",
        content: `你是否要${row.isEnabled ? "停用" : "启用"}此优惠券？`,
        ok: () => {
          this.isLoading = true;
          this.$fetch({
            api,
            para: { id: row.id },
          })
            .then((res) => {
              this.isLoading = false;
              this.getCouponList();
            })
            .catch(() => {
              this.isLoading = false;
            });
        },
      });
    },
    onShowRejectCause(row) {
      this.couponId = row.id;
      this.isShowReasonpopup = true;
      this.rejectCause = row.rejectCause;
    },
    onSure() {
      this.$controller.open({
        name: "couponAdd",
        query: {
          refresh: new Date() - 0,
          id: this.couponId,
          edit: 1,
        },
        title: "编辑优惠券",
      });
      this.isShowReasonpopup = false;
    },
    getChannelList() {
      this.$fetch({
        api: NESTLE_SYSTEM_BACK_SERVER_SYSTEM_SALE_CHANNEL_LIST,
        para: {},
      }).then((res) => {
        this.channelList = res || [];
      });
    },
    getCouponList() {
      let { para } = this;
      this.$fetch({
        api: NESTLE_MARKETING_BACK_SERVER_BONUS_PAGE,
        para,
      }).then((res) => {
        this.dataList = res.pageList;
        this.total = res.total;
      });
    },
    agree() {
      let { tip } = this.$root;
      this.$fetch({
        api: NESTLE_MARKETING_BACK_SERVER_BONUS_AUDIT,
        para: { id: this.couponId },
      }).then((res) => {
        tip("操作成功");
        this.getCouponList();
        this.popupAuditingShow = false;
      });
    },
    refuse() {
      this.popupAuditingShow = false;
      this.popupShow = true;
    },
    save() {
      let { tip } = this.$root;
      if (!this.rejectCause) {
        return tip("请输入驳回原因");
      }
      this.$fetch({
        api: NESTLE_MARKETING_BACK_SERVER_BONUS_CANCEL,
        para: {
          id: this.couponId,
          rejectCause: this.rejectCause,
        },
      }).then((res) => {
        tip("操作成功");
        this.getCouponList();
        this.popupShow = false;
      });
    },
  },
  async created() {
    this.getChannelList();
    this.getCouponList();
  },
  beforeRouteUpdate(to, from, next) {
    this.getCouponList();
    next();
  },
};
</script>

<style lang="postcss" module="css">
.statusStyle {
  display: inline-block;
  width: 5px;
  height: 5px;
  background-color: rgba(0, 0, 0, 0.25);
  border-radius: 50%;
  vertical-align: middle;
  margin-right: 5px;
}
.box {
  position: relative;
  & > .tip {
    position: absolute;
    width: 246px;
    left: -50px;
    top: -45px;
    padding: 10px 15px;
    line-height: 20px;
    background-color: #5b5858;
    color: #fff;
    border-radius: 10px;
    display: none;
    z-index: 10000000000;
    &::after {
      position: absolute;
      content: " ";
      width: 0;
      height: 0;
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-top: 6px solid #5b5858;
      left: 50%;
      top: 100%;
      transform: translateX(-50%);
    }
  }
}
.box:hover {
  cursor: pointer;
}
.box:hover .tip {
  display: block;
}
.textarea {
  width: 400px !important;
  height: 200px;
  & :global(.k-textarea) {
    height: 200px !important;
    resize: none;
  }
}
.inputW {
  width: 230px !important;
}
</style>
